import { formatCurrency } from "@/lib/dashboard-utils";

export function RevenueBlock({
  periodLabel,
  netLabel,
  gross,
  waiver,
  net,
  grossTestId,
  waiverTestId,
  netTestId,
}) {
  return (
    <div className="rounded-xl bg-[#163224] border border-[#2B5E4A]/40 p-4 sm:p-5">
      <div className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.15em] text-[#A3B8AD] mb-3">
        {periodLabel}
      </div>
      <div className="flex items-baseline justify-between gap-2">
        <div className="text-[11px] sm:text-xs text-[#A3B8AD]">Estimate</div>
        <div
          data-testid={grossTestId}
          className="font-mono-data text-xl sm:text-3xl font-light tracking-tighter text-white leading-none"
        >
          {formatCurrency(gross)}
        </div>
      </div>
      <div className="flex items-baseline justify-between gap-2 mt-2">
        <div className="text-[11px] sm:text-xs text-[#F3B5A6]">
          Less co-pays waived
        </div>
        <div
          data-testid={waiverTestId}
          className="font-mono-data text-base sm:text-xl font-light tracking-tighter text-[#F3B5A6] leading-none"
        >
          −{formatCurrency(waiver)}
        </div>
      </div>
      <div className="border-t border-[#2B5E4A]/40 mt-3 pt-3 flex items-baseline justify-between gap-2">
        <div className="text-[11px] sm:text-xs text-white uppercase tracking-[0.1em] font-semibold">
          {netLabel}
        </div>
        <div
          data-testid={netTestId}
          className="font-mono-data text-xl sm:text-3xl font-semibold tracking-tighter text-white leading-none"
        >
          {formatCurrency(net)}
        </div>
      </div>
    </div>
  );
}
